export default __webpack_public_path__ + "static/media/When Two Became One.6e2ae201.png";